import React from 'react';
import styled from 'styled-components';
import { apis } from 'utils/constants';

const STATE_KEY = 'oauth_state';

const generateState = () => {
  const bytes = new Uint8Array(16);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

const startSocialLogin = (provider) => {
  const state = generateState();
  sessionStorage.setItem(STATE_KEY, state);
  const url = `${apis.auth.social.authorize(
    provider,
  )}?state=${encodeURIComponent(state)}`;
  window.location.href = url;
};

const SocialLoginButtons = () => {
  const disabled = process.env.REACT_APP_ENV === 'development';
  return (
    <Container>
      <Divider>
        <Line />
        <DividerLabel>소셜 계정으로 로그인</DividerLabel>
        <Line />
      </Divider>
      <Buttons>
        <KakaoButton
          type="button"
          onClick={() => !disabled && startSocialLogin('kakao')}
          disabled={disabled}
        >
          카카오로 시작하기
        </KakaoButton>
        <NaverButton
          type="button"
          onClick={() => !disabled && startSocialLogin('naver')}
          disabled={disabled}
        >
          네이버로 시작하기
        </NaverButton>
      </Buttons>
      {disabled && (
        <DisabledNote>개발 환경에서는 소셜 로그인이 제한됩니다.</DisabledNote>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0;
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  background: #e5e7eb;
`;

const DividerLabel = styled.span`
  font-size: 11px;
  color: #9fa3a7;
  letter-spacing: -0.02rem;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const BaseButton = styled.button`
  height: 44px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  border: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const KakaoButton = styled(BaseButton)`
  background-color: #fee500;
  color: #191919;
`;

const NaverButton = styled(BaseButton)`
  background-color: #03c75a;
  color: #ffffff;
`;

const DisabledNote = styled.div`
  font-size: 11px;
  color: #9fa3a7;
  text-align: center;
`;

export default SocialLoginButtons;
